module.exports = __webpack_public_path__ + "img/hometips.9bbca573.png";